import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
const TOKEN_KEY = "7ala9_admin_token";

export const api = axios.create({ baseURL: `${BACKEND}/api` });

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) =>
  t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY);

api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const mediaUrl = (id) => `${BACKEND}/api/media/${id}`;

export const waLink = (num, msg) =>
  `https://wa.me/${String(num || "").replace(/\D/g, "")}?text=${encodeURIComponent(msg || "")}`;

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return "حدث خطأ، حاول مرة أخرى.";
}
